import * as React from "react";
import Svg, { Rect, Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={38}
      height={38}
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Rect width={38} height={38} rx={8} fill="#F9F9F9" />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.929 16.644h-1.572A2.357 2.357 0 018 14.287v-3.93A2.357 2.357 0 0110.357 8h17.286A2.357 2.357 0 0130 10.357v3.93a2.357 2.357 0 01-2.357 2.357H26.07v11A2.357 2.357 0 0123.714 30h-9.428a2.357 2.357 0 01-2.357-2.357v-11zM26.07 15.07h1.572a.785.785 0 00.786-.784v-3.93a.785.785 0 00-.786-.785H10.357a.785.785 0 00-.786.785v3.93c0 .433.352.784.786.784h1.572v-1.57h-.786a.786.786 0 010-1.572h15.714a.785.785 0 110 1.571h-.786v1.571zm-7.507 11.654a.783.783 0 00.872 0l2.357-1.57a.786.786 0 00-.872-1.308l-1.135.757v-4.032a.786.786 0 00-1.572 0v4.032l-1.135-.757a.785.785 0 10-.872 1.307l2.357 1.571z"
        fill="#333"
      />
    </Svg>
  );
}

export default SvgComponent;
